import React, { useEffect, useState } from "react";
import { Row, Col, DatePicker, Table, Card, Divider } from "antd";
import { apiCall } from "../../shared/helpers/networkHelper";
import moment from "moment";
import ErrorHandler from "../../shared/classes/ErrorHandler";

const { RangePicker } = DatePicker;

// patientCount = {
//     year_month_number: "2024-06",
//     patient_count: 2
// }[];
// cashier/emr/statistic/patient-count/monthly?start_date=2024-01-01&end_date=2025-10-01

// diagnosis = {
//     icd_10_id: 4,
//     icd_skri: "A00.9",
//     icd_str: "Cholera, unspecified",
//     patient_count: 1
// }[];
// cashier/emr/statistic/patient-count/by-diagnosis?start_date=2024-01-01&end_date=2025-10-01

// gender = { user_gender: 1, patient_count: 3 }[];
// cashier/emr/statistic/patient-count/by-gender?start_date=2024-01-01&end_date=2025-10-01

const visitColumns = [
    {
        title: "Nama Bulan",
        dataIndex: "year_month_number",
        key: "year_month_number",
        render: text => moment(text, "YYYY-MM").format("MMMM YYYY")
    },
    { title: "Jumlah Pasien", dataIndex: "patient_count", key: "patient_count" }
];

const pageTitle = "Report Statistik RME - Laporan Kunjungan Pasien";

export default function PatientVisit() {
    const [dates, setDates] = useState([]);
    const [visitData, setVisitData] = useState([]);

    useEffect(() => {
        apiCall(
            `cashier/emr/statistic/patient-count/monthly?start_date=${moment(
                dates[0]
            ).format("YYYY-MM-DD")}&end_date=${moment(dates[1]).format(
                "YYYY-MM-DD"
            )}`,
            "GET",
            {},
            res => setVisitData(res.data),
            err => ErrorHandler.handleGeneralError(err)
        );
    }, [dates]);

    return (
        <Card title={pageTitle} bordered={false}>
            {/* Date Filter */}
            <Row gutter={16}>
                <Col>
                    <RangePicker value={dates} onChange={setDates} />
                </Col>
            </Row>

            <Divider />

            {/* <Card title="Laporan Gender Pasien"> */}
            <Table
                rowKey="year_month_number"
                columns={visitColumns}
                dataSource={visitData}
                pagination={false}
                bordered
            />
            {/* </Card> */}
        </Card>
    );
}

